class FieldRelation {
    static FR_1v1 = '1:1';
    static FR_1vN = '1:n';
    static FR_Mv1 = 'm:1';

    static reverse(relation) {
        switch (relation) {
            case FieldRelation.FR_1v1: return FieldRelation.FR_1v1;
            case FieldRelation.FR_1vN: return FieldRelation.FR_Mv1;
            case FieldRelation.FR_Mv1: return FieldRelation.FR_1vN;
        }
    }
}

export default FieldRelation;